import PropTypes from 'prop-types';
import Icon from '../../Atoms/Icon/Icon'
import { Card, Image, Link } from '../../Atoms';
import Meta from '../Meta/Meta';

const ToolCard = ({
  title,
  intro,
  type,
  technologies = [],
  date,
  developers = [],
  image,
  href,
  status,
  className = '',
}) => {
  const metaItems = [];
  if (type) metaItems.push({ key: 'Type', value: type });
  if (technologies.length > 0) metaItems.push({ key: 'Technologies', value: technologies.join(' · ') });
  if (developers.length > 0) metaItems.push({ key: 'Developers', value: developers.join(' · ') });

  return (
    <Link href={href} variant="plain" className="block no-underline">
      <Card usage="interactive" className={`card-primary ${className}`}>
        <div className="block">
          <div className="block__header">
            {image ? (
              <div className="media media-16x9">
                <div className="media__content">
                  <Image image={image} fit="cover" />
                </div>
              </div>
            ) : (
              <div className="media media-16x9 flex items-center justify-center bg-gradient-to-br from-primary/20 to-accent/20">
                <Icon name="tool" size="4xl" className="text-neutralMedium" />
              </div>
            )}
          </div>
          <div className="block__body">
            <div className="stack stack-tight">
              <div className="text-item-title line-clamp-2">{title}</div>
              {intro && <div className="text-block-support line-clamp-3">{intro}</div>}
              {metaItems.length > 0 && <Meta items={metaItems} />}
            </div>
          </div>
          {(date || status) && (
            <div className="block__footer">
              <div className="cluster cluster-tight cluster-between">
                <div className="cluster cluster-tight">
                  {date && <div className="text-label text-muted">{date}</div>}
                </div>
                {status && (
                  <div className={`text-label status-${status.variant}`}>
                    {status.label}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Card>
    </Link>
  );
};

ToolCard.propTypes = {
  title: PropTypes.string.isRequired,
  intro: PropTypes.string,
  type: PropTypes.string,
  technologies: PropTypes.arrayOf(PropTypes.string),
  date: PropTypes.string,
  author: PropTypes.string,
  image: PropTypes.object,
  href: PropTypes.string.isRequired,
  status: PropTypes.shape({
    variant: PropTypes.oneOf(['released', 'upcoming', 'draft', 'archived']),
    label: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default ToolCard;